import React, { useCallback, useEffect, useState } from 'react';
import api from '@/lib/axios';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Search, ArrowDownLeft, ArrowUpRight, RefreshCw } from 'lucide-react';

export default function AbgleichTab() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');

  const load = useCallback(async () => {
    try {
      const r = await api.get('/admin/app-verwaltung/activity', { params: { search: search || undefined } });
      setRows(r.data || []);
    } catch (e) { toast.error('Protokoll konnte nicht geladen werden'); }
  }, [search]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  const fmt = (d) => new Date(d).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <div className="relative max-w-sm flex-1">
            <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
            <Input className="pl-9 bg-white" placeholder="Schnellsuche (Person, Aktivität)…" value={search}
                   onChange={(e) => setSearch(e.target.value)} data-testid="abgleich-search" />
          </div>
          <button onClick={load} className="p-2 text-slate-400 hover:text-slate-700" data-testid="abgleich-refresh"><RefreshCw className="w-4 h-4" /></button>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
              <tr>
                <th className="p-3 text-left">Datum</th>
                <th className="p-3 text-left">Zuordnung</th>
                <th className="p-3 text-left">Aktivität</th>
                <th className="p-3 text-left">Richtung</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((a) => (
                <tr key={a.id} data-testid={`abgleich-row-${a.id}`}>
                  <td className="p-3 text-slate-500 whitespace-nowrap">{fmt(a.created_at)}</td>
                  <td className="p-3 font-medium">{a.person_name || '—'}</td>
                  <td className="p-3 text-slate-600">{a.action}</td>
                  <td className="p-3">
                    {a.direction === 'eingang'
                      ? <span className="inline-flex items-center gap-1 text-brand-success text-xs font-medium"><ArrowDownLeft className="w-3.5 h-3.5" /> Eingang</span>
                      : <span className="inline-flex items-center gap-1 text-brand-red text-xs font-medium"><ArrowUpRight className="w-3.5 h-3.5" /> Ausgang</span>}
                  </td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan={4} className="p-10 text-center text-slate-400">Noch keine Aktivitäten protokolliert</td></tr>}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-slate-400 mt-2">Einträge: {rows.length} · Protokolliert werden Kennungs-Freischaltungen, Pinnwand-Beiträge, Freigaben (Aktuelles/Veranstaltungen/Pinnwand) und Konto-Löschungen.</p>
      </div>
    </div>
  );
}
